module.exports = __webpack_public_path__ + "static/credit-excellent-da21f7a9a260c65554b591b7fac17acb.png";